<template>

    <div class="container">

        <StepGuide></StepGuide>

        <div>

            <div class="body textAlignCenter">
                <div class="">
                <span class="icon-error red textAlignCenter font90 column10"></span>
                </div>

                <div v-show="errorType === 'noproducts'">
                    <NoProducts v-bind:printJob="printJob"></NoProducts>
                </div>

                <div v-show="errorType === 'onhold'">
                    <div class="paddingTopLarge"><OnHold></OnHold></div>
                </div>

                <div v-show="errorType === 'incomplete'">
                    <div class="paddingTopLarge"><IncompleteEntry></IncompleteEntry></div>
                </div>

                <div v-show="errorType === 'noresults'">
                    <NoResultsFound v-bind:printJob="printJob" v-bind:issue="issue"></NoResultsFound>
                </div>

                <div v-show="errorType === 'nopdf'">
                    <div class="paddingTopLarge"><NoArtwork></NoArtwork></div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import NoProducts from '@/components/NoProducts.vue';
    import IncompleteEntry from '@/components/IncompleteEntry.vue';
    import NoArtwork from '@/components/NoArtwork.vue';
    import OnHold from '@/components/OnHold.vue';
    import NoResultsFound from '@/components/NoResultsFound.vue';
    import StepGuide from '@/components/StepGuide.vue';

    export default {
        name: "start",
        components: {
            NoProducts,
            IncompleteEntry,
            OnHold,
            NoResultsFound,
            StepGuide,
            NoArtwork
        },
        props: {
            errorType: '',
            printJob: {},
            issue: ''
        },
        data() {
            return {}
        },
        created() {
            console.log(this.issue)
            console.log(this.errorType)
        },
        methods: {}
    };
</script>